import { HelpKustomer } from './types';

/**
 * The calls the browser makes to Kustomer's public knowledge base api -- the same ones
 * help.discountmags.com makes. No key, and CORS-open, so nothing goes through our server.
 */

export type KustomerSearchHit = {
  slug: string;
  title: string;
  categoryId: string;
};

type SearchEntry = {
  attributes?: { slug?: string; title?: string; primaryCategory?: string };
};

export function searchArticles(
  kustomer: HelpKustomer,
  term: string,
  signal?: AbortSignal
): Promise<KustomerSearchHit[]> {
  const query = new URLSearchParams({ term, lang: kustomer.lang });

  return fetch(`${kustomer.baseUrl}/p/v1/kb/deflection/search?${query}`, {
    headers: { Accept: 'application/json' },
    signal,
  })
    .then((response) => (response.ok ? response.json() : { data: [] }))
    .then((payload: { data?: SearchEntry[] }) =>
      (payload.data || []).map((entry) => ({
        slug: entry.attributes?.slug || '',
        title: entry.attributes?.title || '',
        categoryId: entry.attributes?.primaryCategory || '',
      }))
    );
}

function post(url: string, body: object): void {
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).catch(() => {
    // Nothing for the reader to do about a lost view or vote.
  });
}

export function recordView(kustomer: HelpKustomer, articleId: string): void {
  post(`${kustomer.baseUrl}/p/v3/kb/articles/${articleId}/views`, {
    lang: kustomer.lang,
    knowledgeBase: kustomer.knowledgeBase,
  });
}

export function recordFeedback(kustomer: HelpKustomer, articleId: string, helpful: boolean): void {
  post(`${kustomer.baseUrl}/p/v3/kb/articles/${articleId}/feedback?lang=${kustomer.lang}`, {
    rating: helpful ? 'positive' : 'negative',
  });
}
